/* eslint-disable no-param-reassign */
import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import { ESTADOS_GLOBALES_MAP } from 'utils/estadosGlobales';
import { getContenTypePorTipoDePadron } from 'api/catalogos';
import { message } from 'antd';

export const baseURI = 'recaudacion/generaciones-pae/';

/**
    GENERACION OBJECT TYPE
    {
      "id": number,
      "origen_del_credito": number, 👍
      "observaciones": string, 👍
      "sistema": number, 👍
      "padron": number, 👍
      "generacion_de_padron_individual": boolean, 👍
      "limitar_cantidad_de_ejecuciones": boolean, 👍
      "cantidad_de_ejecuciones": number, 👍
      "limitar_meses_sin_ejecuciones_previas": boolean, 👍
      "cantidad_de_meses": number, 👍
      "limitar_por_claves_principales": boolean, 👍
      "clave_principal_inicial": number, 👍
      "clave_principal_final": number, 👍
      "limitar_por_claves_de_padron": boolean, 👍
      "clave_de_padron_inicial": number, 👍
      "clave_de_padron_final": number, 👍
      "limitar_por_adeudos": boolean, 👍
      "importe_de_adeudo_inicial": number, 👍
      "importe_de_adeudo_final": number, 👍
      "limitar_por_periodos_fiscales_anuales": boolean,
      "periodo_inicial": number,
      "periodo_final": number,
      "limitar_por_codigos_postales": boolean,
      "codigo_postal_inicial": number,
      "codigo_postal_final": number,
      "nota_de_errores_al_generar": string,
      "estados_globales": number,
  }
 */

/**
 * GET Generaciones
 * param {object} params
 * @returns {Promise<object>}
 */
export const getGeneraciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Generación
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getGeneracion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Generación
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postGeneracion = async (values) => {
  try {
    values.content_type_padron = getContenTypePorTipoDePadron(values.tipo_de_padron);

    if (!values?.limitar_cantidad_de_ejecuciones) {
      values.cantidad_de_ejecuciones = null;
    }

    if (!values?.limitar_meses_sin_ejecuciones_previas) {
      values.cantidad_de_meses = null;
    }

    if (!values?.limitar_por_claves_principales) {
      values.clave_principal_inicial = null;
      values.clave_principal_final = null;
    }

    if (!values?.limitar_por_claves_de_padron) {
      values.clave_de_padron_inicial = null;
      values.clave_de_padron_final = null;
    }

    if (!values?.limitar_por_codigos_postales) {
      values.codigo_postal_inicial = null;
      values.codigo_postal_final = null;
    }

    if (!values?.limitar_por_periodos_fiscales_anuales) {
      values.periodo_inicial = null;
      values.periodo_final = null;
    }

    if (!values?.limitar_por_adeudos) {
      values.importe_de_adeudo_inicial = null;
      values.importe_de_adeudo_final = null;
    }

    if (!values?.limitar_al_rfc_del_contribuyente) {
      values.rfc_del_contribuyente = null;
    }

    if (values?.generacion_de_padron_individual) {
      values.limitar_cantidad_de_ejecuciones = false;
      values.limitar_meses_sin_ejecuciones_previas = false;
      values.limitar_por_claves_principales = false;
      values.limitar_por_claves_de_padron = false;
      values.limitar_por_codigos_postales = false;
      values.limitar_al_rfc_del_contribuyente = false;

      values.cantidad_de_ejecuciones = null;
      values.cantidad_de_meses = null;
      values.clave_principal_inicial = null;
      values.clave_principal_final = null;
      values.clave_de_padron_inicial = null;
      values.clave_de_padron_final = null;
      values.codigo_postal_inicial = null;
      values.codigo_postal_final = null;
      values.periodo_inicial = null;
      values.periodo_final = null;
      values.importe_de_adeudo_inicial = null;
      values.importe_de_adeudo_final = null;
    }

    const genFound = await getGeneraciones({
      ...values,
      estados_globales: ESTADOS_GLOBALES_MAP.EN_PROCESO,
    });

    if (genFound.length) {
      message.warn('Ya existe una generación con los mismos criterios en proceso. Por favor, espere a que termine la generación anterior para generar una nueva.');
      return false;
    }

    const response = await API.post(baseURI, values);
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Generación
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchGeneracion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Generación
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteGeneracion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, {
      estados_globales: ESTADOS_GLOBALES_MAP.CANCELADO,
    });
    onSuccess(response, 'Cancelado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
